// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"53211bd5","867":"17a477bf"}[chunkId] + ".chunk.js";
};